import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  paperRoot: {
    padding: theme.spacing(12),
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(3),
    },
  },
  /** Wraps the full post composition inside `Paper` (header, body, footer). */
  article: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  headerRoot: {
    width: '100%',
  },
  featureHeaderRoot: {
    maxWidth: '1000px',
  },
  root: {
    width: '100%',
  },
  featureRoot: {
    maxWidth: '800px',
    '& img': {
      width: '650px',
      display: 'block',
      margin: 'auto',
    },
  },
  separator: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  skeleton: {
    transform: 'scale(1,1) !important',
    '&:not(:first-of-type)': {
      marginLeft: theme.spacing(1),
    },
  },
}));
